
import { RewardFeatures } from '@/common/reward/types';
import { AppButton, AppCard, AppFormRow, AppInput, AppSelect } from '@/components';
import { useLiveopsLeaderboardAdd } from '@/modules/liveops/leaderboard/model/add';
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
    name: 'LiveopsLeaderboardAdd',
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetchLinkableRewards, create, rewardOptions } = useLiveopsLeaderboardAdd();

        onMounted(async () => {
            await fetchLinkableRewards();
        });

        return { v$, model, create, rewardOptions, RewardFeatures };
    }
});
